import { ReactNode } from "react"
import AppLayout from "@/layouts/AppLayout"
import DashboardTopbar from "@/components/DashboardTopbar"
import { PlusIcon } from "@heroicons/react/20/solid"
import Button from "@/components/Button"
import PuzzlesList from "@/components/PuzzlesList"
import useCreatePuzzle from "@/hooks/useCreatePuzzle"

const PuzzlesMePage = () => {
  const { createPuzzle, processing } = useCreatePuzzle()

  return (
    <>
      <DashboardTopbar title="My puzzles">
        <div className="flex items-center gap-x-1.5">
          {/* <Button
            loading={isPending}
            style="secondary"
            size="sm"
            href="/puzzles"
          >
            <span>All public puzzles</span>
          </Button> */}
          <Button size="sm" loading={processing} onClick={createPuzzle}>
            <PlusIcon className="h-5 w-5" />
            <span>Add puzzle</span>
          </Button>
        </div>
      </DashboardTopbar>

      <PuzzlesList />
    </>
  )
}

export default PuzzlesMePage

PuzzlesMePage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
